module.exports = __webpack_public_path__ + "img/project-default.6702be0a.png";